import { PhoneCall } from "lucide-react";
import { MagicalIconButton } from "./MagicalIconButton";

interface HumanHandoffButtonProps {
  brandColor: string;
  secondaryColor?: string | null;
  onClick: () => void;
  disabled?: boolean;
}

export const HumanHandoffButton = ({
  brandColor,
  secondaryColor,
  onClick,
  disabled = false,
}: HumanHandoffButtonProps) => {
  return (
    <MagicalIconButton
      onClick={onClick}
      brandColor={brandColor}
      secondaryColor={secondaryColor}
      size={36}
      ariaLabel="Talk to a human"
      label="Talk to human"
      disabled={disabled}
      hoverHint="Connect with a real person on the phone"
      hintPlacement="top"
    >
      <PhoneCall size={16} strokeWidth={2} />
    </MagicalIconButton>
  );
};

export default HumanHandoffButton;
